'use strict';

angular.module('atex.dam').service('DamActivityService', ['$rootScope', '$q', 'AuthenticationService', '$http', 'DamService', '$translate', 'DamNotificationService', 'ContentService', 'CollectionService',
function($rootScope, $q, AuthenticationService, $http, DamService, $translate, DamNotificationService, ContentService, CollectionService) {

  var _appId = "atex.dm.desk";
  var _users = [];
  var self = this;

  var skipActivityService = false;
  var mockData = {
    'edit': false
  };

  // Cache for check activities
  var _getActivitiesCache = {};
  var _ttlGetActivitiesCache = 2000;

  function loadUsers() {
    DamService.getUsers().then(function(users){
        _users = users;
      });
  }

  // delay user load until the configuration end message
  // so anything depending on this service will not force
  // an early authentication message.

  $rootScope.$on("dam:loadConfigurationEnd", function () {
    loadUsers();
  });

  $rootScope.$on("onecms:authenticationSuccess", function() {
    loadUsers();
  });

  // Class
  function EditInfo(editingUserId, currUserId, timestamp, app, params) {
    this.edit = !!editingUserId;
    this.lockedBy = editingUserId;
    this.timestamp = timestamp;
    this.app = app;
    this.byMe = editingUserId && currUserId && editingUserId === currUserId;
    this.params = params;
    this.getUserName = function() {
      if (this.lockedBy) {
        if ( this.params && this.params.By ) {
          return this.params.By;
        }

        return _getUserNameById(this.lockedBy);
      }
    };
  }

  // Private
  function _getUserNameById(id) {
    if (!_getUserNameById.cache) {_getUserNameById.cache = {};}
    if (_getUserNameById.cache[id]) {
      return _getUserNameById.cache[id];
    }
    _users.forEach(function(user) {
      if (user.principalId===id) {
        _getUserNameById.cache[id] = user.name.charAt(0).toUpperCase() + user.name.substring(1);
      }
    });
    return _getUserNameById.cache[id];
  }

  var _getEditInfo = function(data, currUserID)  {
    var users = atex.onecms.ObjectUtils.getByPath(data || {}, 'users');
    for (var key in users) {
      if (users.hasOwnProperty(key)) {
        var apps = users[key]['applications'];
        for (var appKey in apps) {
          if (apps.hasOwnProperty(appKey)) {
            var app = apps[appKey];
            if (app.activity==='edit') {
              return new EditInfo(key, currUserID, app.timestamp, appKey, app.params);
            }
          }
        }
      }
    }
    return new EditInfo();
  };

  var _checkExclusiveLock = function(data, currUserID) {
    var otherLocks = [];
    var myEditInfo;
    var users = atex.onecms.ObjectUtils.getByPath(data || {}, 'users');
    for (var key in users) {
      if (users.hasOwnProperty(key)) {
        var apps = users[key]['applications'];
        for (var appKey in apps) {
          if (apps.hasOwnProperty(appKey)) {
            var app = apps[appKey];
            if (app.activity==='edit') {
              if (currUserID===key) {
                myEditInfo = new EditInfo(key, currUserID, app.timestamp, appKey, app.params);
              } else {
                otherLocks.push(new EditInfo(key, currUserID, app.timestamp, appKey, app.params));
              }
            }
          }
        }
      }
    }
    if (!myEditInfo) {
      throw("Unexpected: the activity should be there!");
    }
    if (otherLocks.length<=0) {
      return myEditInfo;
    }
    // Check if mine is the first lock otherwise return false
    var isFirst = true;
    var otherFound;
    otherLocks.forEach(function(other) {
      if (!otherFound && other.timestamp < myEditInfo.timestamp) {
        otherFound = other;
      }
    });
    if (otherFound) {
      return otherFound;
    }
    return myEditInfo;
  };

  var _getAllActivities = function(ids) {
    var getActivitiesPromises = ids.map(function(contentId) {
      if (_getActivitiesCache[contentId]) {
        return _getActivitiesCache[contentId];
      }
      var url = "/onecms/activities/" + contentId;
      _getActivitiesCache[contentId] = $http.get(url);
      setTimeout(function() {
        delete _getActivitiesCache[contentId];
      }, _ttlGetActivitiesCache);
      return _getActivitiesCache[contentId];
    });
    return $q.all(getActivitiesPromises);
  };

  var _getLockedIds = function(contentIds, currUserId) {
    var deferred = $q.defer();
    _getAllActivities(contentIds).then(function(response) {
      var lockedEditInfos = [];
      response.forEach(function(single, idx) {
        var editInfo = _getEditInfo(single.data, currUserId);
        if (editInfo.edit && !editInfo.byMe) {
          editInfo.contentId = contentIds[idx];
          lockedEditInfos.push(editInfo);
        }
      });
      deferred.resolve(lockedEditInfos);
    }).then(null, function(error) {
      deferred.reject(error);
    });
    return deferred.promise;
  };

  // Public
  self.notifyItemLocked = function(lockingUser) {
    var msg = $translate.getTranslationTable().__ITEM_BEING_EDITED_BY_MSG__ + " " + lockingUser;
    DamNotificationService.addNotification(atex.dam.Notification({ type: 'warning', message: msg }), true);
  };

  self.notifyCollectionItemsLocked = function(lockingUser) {
    var msg =  $translate.getTranslationTable().__ITEMS_IN_COLLECTION_BEING_EDITED_BY_MSG__ + " " + lockingUser;
    DamNotificationService.addNotification(atex.dam.Notification({ type: 'warning', message: msg }), true);
  };

  self.getLockData = function(contentIds)  {
    if (skipActivityService) {
      return $q.when(mockData);
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      _getAllActivities(contentIds).then(function(response) {
        var lockData;
        response.map(function(single) {
          if (!lockData || !lockData.edit) {
            lockData = _getEditInfo(single.data, currentUser.principalId);
          }
        });
        deferred.resolve(lockData);
      }).then(null, function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  self.lock = function(contentIds, tryLockingCollectionItems)  {
    if (skipActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var lockPromises = contentIds.map(function(contentId) {
        var url = "/onecms/activities/" + contentId + "/" + currentUser.principalId + "/" + _appId;
        return $http.put(url, {'activity' : 'edit'});
      });
      $q.all(lockPromises).then(function(responses){
        var allEditInfo;
        responses.forEach(function(response){
          if (!allEditInfo || allEditInfo.byMe) {
            allEditInfo = _checkExclusiveLock(response.data, currentUser.principalId);
          }
        });
        if (!allEditInfo || allEditInfo.byMe) {
          deferred.resolve(responses);
        } else {
          // There is some object that was previously locked by someone else, we have to revert all the lock activities!
          var deletePromises = responses.map(function(response) {
            return $http.delete(response.config.url);
          });
          $q.all(deletePromises).then(function(responses){
            if (tryLockingCollectionItems) {
              self.notifyCollectionItemsLocked(allEditInfo.getUserName());
              deferred.reject({childsLocked: true, notified: true});
            } else {
              self.notifyItemLocked(allEditInfo.getUserName());
              deferred.reject({objectLocked: true, notified: true});
            }
          }).then(null, function(error){
            deferred.reject(error);
          });
        }
      }).then(null, function(error){
        var errMsg = atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message');
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: errMsg }), true);
        error.notified = true;
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  // remove current user activity
  self.unlock = function(contentIds)  {
    if (skipActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var unlockPromises = contentIds.map(function(contentId) {
        var url = "/onecms/activities/" + contentId + "/" + currentUser.principalId + "/" + _appId;
        return $http.delete(url);
      });
      $q.all(unlockPromises).then(function(responses) {
        deferred.resolve(responses);
      }).then (null, function(error) {
        var errMsg = atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message');
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: errMsg }), true);
        error.notified = true;
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  // remove other user activity
  self.removeActivity = function(contentId, principalId, appId)  {
    if (skipActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var url = "/onecms/activities/" + contentId + "/" + principalId + "/" + appId;
      $http.delete(url).then(function(response) {
        deferred.resolve(response);
      }).then (null, function(error) {
        var errMsg = atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message');
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: errMsg }), true);
        error.notified = true;
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  // returns an array of locked items with EditInfo
  self.getLockedItems = function(contentIds)  {
    if (skipActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      _getLockedIds(contentIds, currentUser.principalId).then(function(lockedEditInfos) {
        var lockedItems = [];
        var getPromises = lockedEditInfos.map(function(editInfo) {
          var def = $q.defer();
          ContentService.getContent({ id: editInfo.contentId}).then(function(response){
            response.data.lockData = editInfo;
            def.resolve(response);
          }).then (null, function(error) {
            def.reject(error);
          });
          return def.promise;
        });
        $q.all(getPromises).then(function(responses) {
          deferred.resolve(responses);
        });
      }).then (null, function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };


  self.lockCollection = function(collectionId, skipContents) {
    if (skipActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var allChildsIDs = [];
      var collectionLocked = false;
      self.lock([collectionId]).then(function(lockData) {
        collectionLocked = true;
        if (skipContents) {
          return [];
        }
        return CollectionService.getCollectionChildsIDs(collectionId);
      }).then(function(contentIds){
        if (skipContents) {
          return $q.when();
        }
        allChildsIDs = contentIds;
        return self.lock(contentIds, true);
      }).then(function(lockData){
        deferred.resolve(lockData);
      }).then(null, function(error) {
        if (collectionLocked) {
          self.unlock([collectionId]);
        }
        if (error.childsLocked) {
          error.allChildsIDs = allChildsIDs;
        }
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  self.skipActivityService = function() {
    return skipActivityService;
  };

}]);
